'use strict';

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var Icon = require('../Icon-8d79bebe.js');

var React = _interopDefault(require('react'));

require('@carbon/icon-helpers');

require('prop-types');

var Rocket32 = /*#__PURE__*/React.forwardRef(function Rocket32(props, ref) {
  return React.createElement(Icon.Icon, Icon._extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref
  }, props), React.createElement("rect", {
    width: "11.31",
    height: "2",
    x: "6.34",
    y: "19",
    transform: "rotate(-45 11.995 20.002)"
  }), React.createElement("path", {
    d: "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
  }), props.children);
});
module.exports = Rocket32;